import { MouseEvent } from 'react'
import styled from 'styled-components'
import Image from 'next/image'

import { Action } from '@/components'
import Text from '@/components/atomic/atoms/Text'
import { postAmplitude, postGA } from '@/core/lib'

const Wrapper = styled.li`
  /* css */
  box-sizing: border-box;
  margin-bottom: 24px;
  cursor: pointer;

  h3 img {
    margin-left: 5px;
  }

  .sub-content {
    display: flex;
    justify-content: space-between;
    padding: 0 0 3px 0;
  }
  .sub-content span {
    font-size: 12px;
    color: #666666;
  }

  border-bottom: 1px solid #dbdbdb;

  .post-img-box {
    background: linear-gradient(-45deg, #e0e0e0, #e0e0e0, #f1f1f1, #f1f1f1);
    background-size: 400% 400%;
    animation: gradientBG 1s ease-in infinite;
    width: 100%;
    max-height: 213px;
    border-radius: 8px;
    position: relative;
    border-radius: 8px;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .post-img-box img {
    position: relative;
    width: 100%;
    height: 100%;
    object-fit: cover;
    /* height: 100%; */
  }
`

type Props = {
  post: Post
  className?: string
  onClick?: (e: MouseEvent<HTMLLIElement>) => void
}

const PostListItem: React.FC<Props> = (props: Props) => {
  const { post, onClick, className } = props
  const actionProperties = {
    column_id: post._id,
    column_title: post.title,
  }

  return (
    <Wrapper className={className} onClick={onClick}>
      {onClick ? (
        <PostListItemUI post={post} />
      ) : (
        <Action
          trackEvent={() => {
            postGA('POST_ITEM', 'click', post._id)
            postAmplitude('click_column_list_contents', actionProperties)
          }}
          href={`/posts/${post._id}`}
          newTab
        >
          <PostListItemUI post={post} />
        </Action>
      )}
    </Wrapper>
  )
}

const PostListItemUI = ({ post }: { post: Post }) => {
  return (
    <>
      <div className="post-img-box">
        <Image
          src={post.thumbnailUrl}
          alt=""
          sizes="100vw"
          style={{
            width: '100%',
            height: 'auto',
          }}
          width="300"
          height="157"
        />
      </div>
      <div>
        <Text type="title3" element="h3" numberOfLines={2}>
          {post.title}
        </Text>
        <div className="sub-content">
          <span className="date">{post.date}</span>
          <span className="author">{post.authorId}</span>
        </div>
      </div>
    </>
  )
}

export default PostListItem
